import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import { SidebarProvider } from "./context/SidebarContext";
import { setAlert } from "./action/alert";
import customConfig from "./config";

const normalizeError = (reason) => {
  if (!reason) return {};
  if (typeof reason === "string") {
    return { message: reason };
  }
  return reason;
};

const isTimeoutOrNetworkError = (reason) => {
  const err = normalizeError(reason);
  const isCancelled = err === "REQUEST_CANCELLED" || err?.message === "REQUEST_CANCELLED";
  const name = err?.name?.toLowerCase?.() || "";
  const message = err?.message?.toLowerCase?.() || "";
  const isTimeout =
    err?.isTimeout ||
    err?.code === "ECONNABORTED" ||
    name.includes("timeout") ||
    message.includes("timeout") ||
    message.includes("timed out");
  const isNetwork =
    err?.isNetworkError ||
    message === "network error" ||
    (!err?.response && !isTimeout);

  return { err, isTimeout, isNetwork, isCancelled };
};

const handleGlobalTimeoutOrNetworkError = (reason, event) => {
  try {
    const { err, isTimeout, isNetwork, isCancelled } = isTimeoutOrNetworkError(reason);
    if (!(isTimeout || isNetwork || isCancelled)) {
      return false;
    }

    if (event?.preventDefault) event.preventDefault();
    if (event?.stopImmediatePropagation) event.stopImmediatePropagation();

    if (!isCancelled) {
      const msg = err?.userMessage ?? (isTimeout ? customConfig.TIMEOUT_ERROR : customConfig.NETWORK_ERROR);
      store.dispatch(setAlert(msg, "danger"));
    }

    return true;
  } catch (e) {
    return false;
  }
};

// Handle unhandled promise rejections (e.g. API timeouts) to show user-friendly message instead of error overlay
window.addEventListener("unhandledrejection", (event) => {
  handleGlobalTimeoutOrNetworkError(event?.reason, event);
}, true);

window.addEventListener("error", (event) => {
  handleGlobalTimeoutOrNetworkError(event?.error || event?.message, event);
}, true);

window.onunhandledrejection = (event) => {
  const handled = handleGlobalTimeoutOrNetworkError(event?.reason, event);
  return handled ? true : undefined;
};

window.onerror = (message, source, lineno, colno, error) => {
  const handled = handleGlobalTimeoutOrNetworkError(error || message, null);
  return handled ? true : undefined;
};

let root = document.getElementById("root");

ReactDOM.render(
  <Provider store={store}>
    <SidebarProvider>
      <App />
    </SidebarProvider>
  </Provider>,
  root
);

